export function reportNumber(value, digits = 0) {
  if (value === null || typeof value === 'undefined') return '—';
  const number = Number(value);
  return Number.isFinite(number)
    ? number.toLocaleString('ro-RO', { maximumFractionDigits: digits })
    : '—';
}

export function reportRate(value) {
  return value === null || typeof value === 'undefined' ? '—' : `${reportNumber(value, 2)}%`;
}

export function csvCell(value) {
  let text = value === null || typeof value === 'undefined' ? '' : String(value);
  if (typeof value === 'string' && /^\s*[=+@-]/.test(text)) text = `'${text}`;
  return `"${text.replace(/"/g, '""')}"`;
}

export function reportMetadataRows(response = {}) {
  return [
    ['As of', response.as_of || response.generated_at],
    ['Timezone', response.period?.timezone || 'Europe/Bucharest'],
    ['Current client profile county', response.filters?.county?.label],
    ['Definitions version', response.definitions_version],
    ['Qualifying purchases', 'Statuses 1, 2, 5; non-negative amount; financial reversal documents excluded'],
    ['History', response.history_basis || response.purchase_behavior?.history_basis],
    ['Population', 'Non-erased client accounts; anonymous client excluded; current profile and order status'],
  ];
}

export function downloadReportCsv(rows, filename) {
  const text = rows.map((row) => row.map(csvCell).join(',')).join('\r\n');
  const url = URL.createObjectURL(new Blob(['\ufeff', text], { type: 'text/csv;charset=utf-8;' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

export function reportErrorMessage(xhr) {
  if (xhr?.status === 401) return 'Your session has expired. Sign in again to load this report.';
  if (xhr?.status === 403) return 'You do not have permission to view this report.';
  if (xhr?.status === 400) return 'The report filters are invalid. Check the dates and selected window.';
  return 'The report could not be loaded. Retry to refresh the result.';
}
